<template>
    <i :class="[caret, 'fa caret-icon']" />
</template>

<script>
export default {
    name: 'AttributesDropdownCaretIcon',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    computed: {
        caret() {
            return this.isOpen ? 'fa-angle-up' : 'fa-angle-down'
        },
    },
}
</script>

<style lang="scss" scoped>
.caret-icon {
    font-size: 16px;
    color: #ffffff;
    padding: 3px 6px;
    background-color: #6e6e6e;
    display: inline-block;
}
</style>
